if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.productId = this.dataset.productId;
        this.selectedVariantDefault = this.dataset.disableSelectedVariantDefault === "true";

        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        const queryString = window.location.search;
        const hasQueryString = queryString.includes("?variant=");
        if (!hasQueryString && this.selectedVariantDefault && this.variantData && this.variantData.length > 1)
          this.disableSelectedVariantDefault();

        this.init();
        this.setStickyAddToCartHeight();

        this.addEventListener("change", () => {
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          this.updateButton(true, "", false);
          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut);
          }
        });

        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });
        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        // Sticky sempre visível desde o início (não depende mais de scroll)
        this.container.style.setProperty("--m-translate-y", 0);
        document.documentElement.classList.add("stick-atc-show");

        // Inicializa os pickers de cor/tamanho (se houver)
        this.initStickyPickers();

        if (!this.mainAddToCart) return;
        const { prodTitle, mainImage, addToCart, buyNowBtn, foxkitBtn } = this.domNodes;
        if (buyNowBtn) this.enable_dynamic_checkout = true;

        if (prodTitle) prodTitle.addEventListener("click", () => __scrollToTop());
        if (mainImage) mainImage.addEventListener("click", () => __scrollToTop());

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;
          const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
          customFields &&
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");
              if (field.value == "" && field.hasAttribute("required")) {
                hasCustomFieldRequired = true;
              }
            });
          hasCustomFieldRequired &&
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);
                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                }
              },
              true
            );
          }
          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        this.syncWithMainProductForm();

        // O tema ja marca uma variante valida no picker da pagina, e o botao
        // principal nasce liberado. Como nenhum evento de change dispara no
        // load, a barra ficava com "Selecione a cor" e o botao morto num
        // produto que o cliente ja podia comprar. Nao adota quando o tema
        // pede explicitamente para nao pre-selecionar e a URL nao traz
        // ?variant=, que e o caso em que a escolha tem mesmo que ser feita.
        const urlTemVariant = window.location.search.includes("variant=");
        if (urlTemVariant || !this.selectedVariantDefault) {
          this.adoptInitialVariant();
        }
      }

      // Le a variante que o picker da pagina ja tem no load e espelha na
      // barra. O custom element do picker pode nao ter subido ainda, por
      // isso as tentativas.
      adoptInitialVariant(tentativa = 0) {
        const picker = document.querySelector("variant-picker");
        const variant = picker && picker.currentVariant;
        if (!variant) {
          if (tentativa < 5) setTimeout(() => this.adoptInitialVariant(tentativa + 1), 120);
          return;
        }
        const variantInput = this.querySelector('[name="id"]');
        if (variantInput) variantInput.value = variant.id;
        this.mirrorVariantIntoStickyPickers(variant);
      }

      // ============================================================
      // Sticky Pickers (cor + tamanho + qty + ATC)
      // ------------------------------------------------------------
      // Ler o JSON de variants embutido, montar bolinhas de cor com
      // o swatch correto (usando MinimogSettings._colorSwatches), e
      // ao trocar a cor popular o select de tamanhos com APENAS as
      // opções disponíveis para a cor selecionada. Quando ambos
      // estiverem definidos (ou quando há só um picker), atualiza
      // o input hidden name="id" com a variant correspondente e
      // dispara um change event para o resto da lógica.
      // ============================================================
      initStickyPickers() {
        const pickersRoot = this.querySelector(".sticky-pickers");
        if (!pickersRoot) return;
        this.pickersRoot = pickersRoot;
        this.colorPosition = parseInt(pickersRoot.dataset.colorPosition, 10) || 0;
        this.sizePosition = parseInt(pickersRoot.dataset.sizePosition, 10) || 0;

        // Lê variants do JSON específico do sticky (não confundir com o
        // do quickview/main)
        const variantsScript = this.container.querySelector(
          'script[data-sticky-variants]'
        );
        if (variantsScript) {
          try {
            this.stickyVariants = JSON.parse(variantsScript.textContent);
          } catch (e) {
            this.stickyVariants = this.variantData || [];
          }
        } else {
          this.stickyVariants = this.variantData || [];
        }

        this.colorDropdown = pickersRoot.querySelector("[data-sticky-color-dropdown]");
        this.colorTrigger = pickersRoot.querySelector("[data-sticky-color-trigger]");
        this.colorTriggerDot = pickersRoot.querySelector("[data-sticky-color-trigger-dot]");
        this.colorTriggerLabel = pickersRoot.querySelector("[data-sticky-color-trigger-label]");
        this.colorList = pickersRoot.querySelector("[data-sticky-color-list]");
        this.colorOptions = pickersRoot.querySelectorAll(".sticky-color-option");

        this.sizeDropdown = pickersRoot.querySelector("[data-sticky-size-dropdown]");
        this.sizeTrigger = pickersRoot.querySelector("[data-sticky-size-trigger]");
        this.sizeTriggerLabel = pickersRoot.querySelector("[data-sticky-size-trigger-label]");
        this.sizeList = pickersRoot.querySelector("[data-sticky-size-list]");

        this.hiddenIdInput = this.querySelector('[data-sticky-variant-id]');

        this.applyColorSwatches();
        this.bindStickyColorEvents();
        this.bindStickySizeEvents();

        // Estado inicial: se NÃO houver picker de cor, popula o size
        // dropdown com todos os valores e habilita
        if (this.colorOptions.length === 0 && this.sizeDropdown) {
          this.populateStickySizeList(null);
        }
        // Se há apenas UMA cor disponível, pré-seleciona. O click()
        // reaproveita todo o fluxo da seleção manual: label/bolinha do
        // trigger, popular os tamanhos daquela cor, resolver a variant
        // e sincronizar com o variant-picker principal da página.
        if (this.colorOptions.length === 1) {
          this.colorOptions[0].click();
        }
        // Estado inicial: ATC desabilitado até seleção completa
        this.refreshStickyAtcState();
      }

      // Resolve a cor real (string CSS) a partir do MinimogSettings.
      // Retorna { type: 'gradient'|'color', value: string } ou null.
      resolveColorValue(rawValue) {
        const swatches = (window.MinimogSettings && window.MinimogSettings._colorSwatches) || [];
        const value = (rawValue || "").toLowerCase();
        const customColor = swatches.find((c) => c.key === value);
        const colorValue = (customColor && customColor.value) || value;
        if (!colorValue) return null;
        if (colorValue.includes("|")) {
          const colors = colorValue.split("|").map((c) => c.trim());
          let gradient = "";
          if (colors.length === 2) {
            gradient = `conic-gradient(${colors[0]} 0deg 180deg, ${colors[1]} 180deg 360deg)`;
          } else if (colors.length >= 3) {
            gradient = `conic-gradient(${colors[0]} 0deg 120deg, ${colors[1]} 120deg 240deg, ${colors[2]} 240deg 360deg)`;
          }
          return { type: "gradient", value: gradient };
        }
        return { type: "color", value: colorValue };
      }

      paintDot(dotEl, rawValue) {
        if (!dotEl) return;
        const resolved = this.resolveColorValue(rawValue);
        if (!resolved) return;
        // Reset
        dotEl.style.background = "";
        dotEl.style.backgroundColor = "";
        if (resolved.type === "gradient") {
          dotEl.style.background = resolved.value;
        } else {
          dotEl.style.backgroundColor = resolved.value;
        }
      }

      // Aplica cor real em cada bolinha das opções do dropdown
      applyColorSwatches() {
        this.colorOptions.forEach((opt) => {
          const dot = opt.querySelector(".sticky-color-option__dot");
          this.paintDot(dot, opt.dataset.colorValue);
        });
      }

      bindStickyColorEvents() {
        if (!this.colorTrigger || !this.colorList) return;

        // Toggle do dropdown
        this.colorTrigger.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const isOpen = !this.colorList.hasAttribute("hidden");
          if (isOpen) {
            this.closeColorDropdown();
          } else {
            this.openColorDropdown();
          }
        });

        // Selecionar uma cor
        this.colorOptions.forEach((opt) => {
          opt.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            const value = opt.dataset.colorValue;
            this.selectedColor = value;

            // Atualiza visual do trigger
            this.colorOptions.forEach((o) => o.classList.remove("is-selected"));
            opt.classList.add("is-selected");
            this.paintDot(this.colorTriggerDot, value);
            if (this.colorTriggerDot) this.colorTriggerDot.classList.add("has-color");
            if (this.colorTriggerLabel) this.colorTriggerLabel.textContent = value;

            this.closeColorDropdown();
            this.populateStickySizeList(this.selectedColor);
            this.resolveStickyVariant();
            // Sincroniza com o variant-picker da página para trocar
            // as imagens do produto pela cor selecionada.
            // A flag evita o eco: o picker principal emite VARIANT_CHANGE e o
            // espelhamento de volta repopularia a lista de tamanhos, zerando a
            // seleção que o cliente acabou de fazer.
            this._syncingFromSticky = true;
            this.syncMainPickerColor(value);
            setTimeout(() => {
              this._syncingFromSticky = false;
            }, 0);
          });
        });

        // Fechar ao clicar fora
        this._colorOutsideHandler = (e) => {
          if (!this.colorDropdown.contains(e.target)) {
            this.closeColorDropdown();
          }
        };
        document.addEventListener("click", this._colorOutsideHandler);
      }

      openColorDropdown() {
        if (!this.colorList) return;
        this.colorList.removeAttribute("hidden");
        this.colorTrigger.setAttribute("aria-expanded", "true");
        this.colorDropdown.classList.add("is-open");
      }

      closeColorDropdown() {
        if (!this.colorList) return;
        this.colorList.setAttribute("hidden", "");
        this.colorTrigger.setAttribute("aria-expanded", "false");
        this.colorDropdown.classList.remove("is-open");
      }

      // Sincroniza a cor selecionada com o <variant-picker> da página
      // para que ele atualize a galeria de imagens do produto.
      // O variant-picker tolera seleção parcial: se só a cor for marcada,
      // ele encontra a 1ª variant disponível com aquela cor e atualiza
      // currentVariant + chama updateMedia() (que reordena os slides).
      syncMainPickerColor(colorValue) {
        const variantPicker = document.querySelector("variant-picker");
        if (!variantPicker) return;
        const colorName = this.pickersRoot.dataset.colorName;
        if (!colorName) return;

        // 1) Tenta picker do tipo radio (color/button/image swatches)
        const radios = variantPicker.querySelectorAll('input[type="radio"]');
        for (const input of radios) {
          if (input.name === colorName && input.value === colorValue) {
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }

        // 2) Tenta picker do tipo dropdown (<select name="options[Cor]">)
        const selects = variantPicker.querySelectorAll("select");
        for (const select of selects) {
          if (select.name === `options[${colorName}]`) {
            select.value = colorValue;
            select.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }
      }

      bindStickySizeEvents() {
        if (!this.sizeTrigger || !this.sizeList) return;

        // Toggle do dropdown
        this.sizeTrigger.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (this.sizeTrigger.disabled) return;
          const isOpen = !this.sizeList.hasAttribute("hidden");
          if (isOpen) {
            this.closeSizeDropdown();
          } else {
            this.closeColorDropdown();
            this.openSizeDropdown();
          }
        });

        // Fecha ao clicar fora
        this._sizeOutsideHandler = (e) => {
          if (!this.sizeDropdown.contains(e.target)) {
            this.closeSizeDropdown();
          }
        };
        document.addEventListener("click", this._sizeOutsideHandler);
      }

      openSizeDropdown() {
        if (!this.sizeList) return;
        this.sizeList.removeAttribute("hidden");
        this.sizeTrigger.setAttribute("aria-expanded", "true");
        this.sizeDropdown.classList.add("is-open");
      }

      closeSizeDropdown() {
        if (!this.sizeList) return;
        this.sizeList.setAttribute("hidden", "");
        this.sizeTrigger.setAttribute("aria-expanded", "false");
        this.sizeDropdown.classList.remove("is-open");
      }

      // Popula a lista do dropdown de tamanho com os valores que
      // possuem variant disponível para a cor passada. Se colorValue
      // for null, popula com todos os tamanhos disponíveis.
      populateStickySizeList(colorValue) {
        if (!this.sizeList) return;
        const sizeKey = `option${this.sizePosition}`;
        const colorKey = `option${this.colorPosition}`;
        const seen = new Set();
        const sizes = [];
        this.stickyVariants.forEach((v) => {
          if (!v) return;
          if (colorValue && v[colorKey] !== colorValue) return;
          if (!v.available) return;
          const sizeVal = v[sizeKey];
          if (sizeVal && !seen.has(sizeVal)) {
            seen.add(sizeVal);
            sizes.push(sizeVal);
          }
        });

        // Limpa lista atual
        this.sizeList.innerHTML = "";

        // Cria <li><button> para cada tamanho
        sizes.forEach((s) => {
          const li = document.createElement("li");
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "sticky-size-option";
          btn.dataset.sizeValue = s;
          btn.setAttribute("role", "option");
          const label = document.createElement("span");
          label.className = "sticky-size-option__label";
          label.textContent = s;
          btn.appendChild(label);
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.selectedSize = s;
            // Marca selected visualmente
            this.sizeList.querySelectorAll(".sticky-size-option").forEach((o) => {
              o.classList.remove("is-selected");
            });
            btn.classList.add("is-selected");
            // Atualiza label do trigger
            if (this.sizeTriggerLabel) this.sizeTriggerLabel.textContent = s;
            this.closeSizeDropdown();
            this.resolveStickyVariant();
          });
          li.appendChild(btn);
          this.sizeList.appendChild(li);
        });

        // Habilita o trigger
        this.sizeTrigger.disabled = false;
        this.sizeDropdown.parentElement.classList.remove("is-disabled");
        // Reseta label e seleção
        if (this.sizeTriggerLabel) this.sizeTriggerLabel.textContent = "Selecione o tamanho";
        this.selectedSize = null;
      }

      // Encontra a variant que casa com cor + tamanho selecionados
      // (ou só com o que houver). Atualiza hidden input + dispara change.
      resolveStickyVariant() {
        const colorKey = `option${this.colorPosition}`;
        const sizeKey = `option${this.sizePosition}`;
        const variant = this.stickyVariants.find((v) => {
          if (this.colorPosition && this.selectedColor && v[colorKey] !== this.selectedColor) return false;
          if (this.sizePosition && this.selectedSize && v[sizeKey] !== this.selectedSize) return false;
          // Se não houver picker pra essa dimensão, ignora
          if (this.colorPosition && !this.selectedColor) return false;
          if (this.sizePosition && !this.selectedSize) return false;
          return true;
        });

        if (variant && this.hiddenIdInput) {
          this.hiddenIdInput.value = variant.id;
          // Dispara change para o handler de updateButton
          this.dispatchEvent(new Event("change", { bubbles: true }));
        }
        this.refreshStickyAtcState(variant);
      }

      // Habilita/desabilita o botão ATC conforme estado dos pickers
      refreshStickyAtcState(variant) {
        const productForm = this.querySelector(".sticky-atc-form");
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const needsColor = this.colorOptions && this.colorOptions.length > 0;
        const needsSize = !!this.sizeDropdown;
        const colorOk = !needsColor || !!this.selectedColor;
        const sizeOk = !needsSize || !!this.selectedSize;
        const ready = colorOk && sizeOk && (!variant || variant.available);

        if (ready) {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");
        } else {
          addButton.setAttribute("disabled", "disabled");
          addButton.classList.add("disabled");
        }
      }

      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", sectionHeight);
      }

      disableSelectedVariantDefault() {
        const pickerSelects = this.querySelector(".m-product-option--dropdown-select");
        if (!pickerSelects) return;
        pickerSelects.value = "";
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(".sticky-atc-form");
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > .m-add-to-cart--text-grudado');

        if (!addButton || !addButtonText) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");
          addButtonText.textContent = window.MinimogStrings.addToCartShort;
        }
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, async (variant) => {
          if (!variant) return;
          variantInput.value = variant.id;
          if (this._syncingFromSticky) return;
          this.mirrorVariantIntoStickyPickers(variant);
        });
      }

      // Espelha para dentro do sticky a variant que o cliente escolheu no
      // picker principal da página. Sem isso o botão continuava travado:
      // refreshStickyAtcState só olha selectedColor/selectedSize, e esses
      // campos eram preenchidos apenas quando a escolha saía do próprio
      // sticky. No mobile, onde a barra é a forma natural de comprar, o
      // cliente escolhia cor e tamanho na página e o botão não liberava.
      mirrorVariantIntoStickyPickers(variant) {
        if (!this.pickersRoot) {
          // Sem pickers próprios o botão só depende da disponibilidade.
          this.updateButton(!variant.available, window.MinimogStrings.soldOut);
          return;
        }

        // A cor precisa vir antes: populateStickySizeList zera o tamanho.
        if (this.colorPosition && this.colorOptions && this.colorOptions.length) {
          const cor = variant[`option${this.colorPosition}`];
          if (cor && cor !== this.selectedColor) {
            this.selectedColor = cor;
            this.colorOptions.forEach((o) => o.classList.toggle("is-selected", o.dataset.colorValue === cor));
            this.paintDot(this.colorTriggerDot, cor);
            if (this.colorTriggerDot) this.colorTriggerDot.classList.add("has-color");
            if (this.colorTriggerLabel) this.colorTriggerLabel.textContent = cor;
            this.populateStickySizeList(cor);
          }
        }

        if (this.sizePosition && this.sizeDropdown) {
          const tamanho = variant[`option${this.sizePosition}`];
          if (tamanho) {
            this.selectedSize = tamanho;
            this.sizeList.querySelectorAll(".sticky-size-option").forEach((o) => {
              o.classList.toggle("is-selected", o.dataset.sizeValue === tamanho);
            });
            if (this.sizeTriggerLabel) this.sizeTriggerLabel.textContent = tamanho;
          }
        }

        this.refreshStickyAtcState(variant);
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }

      disconnectedCallback() {}
    }
  );
}
